import React from 'react';
import { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/react';
import { renderPrntImageFile } from '../../helpers/common';
import { LightshotEmbedAttributesInterface } from '../../interfaces/tiptapInterface';
import createEmbed from './createEmbed';

export interface LightshotEmbedOptions {
  HTMLAttributes?: LightshotEmbedAttributesInterface;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    lightshotEmbed: {
      setLightshotEmbed: (options: { url: string; previewLink: string }) => ReturnType;
    };
  }
}

// React NodeView Component using renderPrntImageFile
const LightshotEmbedComponent: React.FC<NodeViewProps> = ({ node }) => {
  const { url, previewLink } = node.attrs;

  return <NodeViewWrapper className='lightshot-embed-wrapper'>{renderPrntImageFile(url, previewLink)}</NodeViewWrapper>;
};

export const LightshotEmbed = createEmbed({
  name: 'lightshotEmbed',
  tag: 'div.prnt-preview-main-div',
  component: LightshotEmbedComponent,
  draggable: false,
  attributes: {
    url: { default: '' },
    previewLink: { default: '' }
  },
  parseHTMLGetAttrs: (dom: HTMLElement) => ({
    url: dom.getAttribute('url'),
    previewLink: dom.querySelector('.prnt-inbox-image img')?.getAttribute('src') || ''
  }),
  renderHTMLAttributes: (HTMLAttributes) => {
    return {
      class: 'prnt-preview-main-div',
      url: HTMLAttributes?.url,
      name: HTMLAttributes.previewLink
    };
  }
});
